'use strict';
angular.module('resourceCenterinitComDataModule', [])
    .factory('initComDataService', function() {
        return {
            timeRange: function(argument) {
                return [{
                    name: '全部时间',
                    value: '0'
                }, {
                    name: '今天',
                    value: '0d'
                }, {
                    name: '昨天',
                    value: '1d'
                }, {
                    name: '最近三天',
                    value: '2d'
                }, {
                    name: '最近半个月',
                    value: '15d'
                }, {
                    name: '近一个月',
                    value: '1m'
                }];
            },
            newsType: function() {
                return [{
                    name: '全部稿件',
                    value: ''
                }, {
                    name: '新闻稿件',
                    value: '1'
                }, {
                    name: '图集稿件',
                    value: '2'
                }];
            },
            resourceCenterNewsType: function(){
                return [{
                    name: '全部稿件',
                    value: ''
                }, {
                    name: '文字稿件',
                    value: '1'
                }, {
                    name: '图片稿件',
                    value: '2'
                }, {
                    name: '视频稿件',
                    value: '3'
                }];
            },
            shareNewsType: function() {
                return [{
                    name: '全部稿件',
                    value: ''
                }, {
                    name: '新闻稿件',
                    value: '1'
                }, {
                    name: '图集稿件',
                    value: '2'
                }, {
                    name: '视频稿件',
                    value: '7'
                }, {
                    name: '链接稿件',
                    value: '4'

                /* }, {
                    name: "活动稿件",
                    value: "5"
                }, {
                    name: "话题稿件",
                    value: "6"*/
                }, {
                    name: '直播稿件',
                    value: '8'
                }];
            },
            picSize: function() {
                return [{
                    name: '全部',
                    value: ''
                }, {
                    name: '特大',
                    value: '1'
                }, {
                    name: '大',
                    value: '2'
                }, {
                    name: '中',
                    value: '3'
                }, {
                    name: '小',
                    value: '4'
                }];
            },
            videoType: function() {
                return [{
                    name: '全部',
                    value: ''
                }, {
                    name: '视频',
                    value: '1'
                }, {
                    name: '音频',
                    value: '2'
                }];
            },
            definitionLevel: function() {
                return [{
                    name: '全部',
                    value: ''
                }, {
                    name: '高清',
                    value: '1'
                }, {
                    name: '普通',
                    value: '2'
                }, {
                    name: '流畅',
                    value: '3'
                }];
            },
            sourceWebsite: function() {
                return [{
                    name: '全部稿件',
                    value: ''
                }, {
                    name: '新浪',
                    value: '1'
                }, {
                    name: '腾讯',
                    value: '2'
                }];
            },
            docType: function() {
                return [{
                    name: '全部稿件',
                    value: ''
                }, {
                    name: '政治新闻',
                    value: '1'
                }, {
                    name: '经济新闻',
                    value: '2'
                }, {
                    name: '文化新闻',
                    value: '3'
                }, {
                    name: '社会新闻',
                    value: '4'
                }, {
                    name: '生态新闻',
                    value: '5'
                }, {
                    name: '体育新闻',
                    value: '6'
                }, {
                    name: '图片新闻',
                    value: '7'
                }, {
                    name: '言论评论',
                    value: '8'
                }];
            },
            newsdocTypes: function() {
                return [{
                    name: '稿件类型',
                    value: ''
                }, {
                    name: '新闻稿件',
                    value: '1'
                }, {
                    name: '图集稿件',
                    value: '2'
                }];
            },
            sourceLevel: function() {
                return [{
                    name: '信源等级',
                    value: ''
                }, {
                    name: '全部',
                    value: '0'
                }, {
                    name: '顶级',
                    value: '1'
                }, {
                    name: '高级',
                    value: '2'
                }, {
                    name: '一般',
                    value: '3'
                }];
            },
            layouts: function() {
                return [{
                    name: '版面',
                    value: ''
                }, {
                    name: '全部',
                    value: '0'
                }, {
                    name: '版面A',
                    value: '1'
                }, {
                    name: '版面B',
                    value: '2'
                }];
            },
            edition: function() {
                return [{
                    name: '版次',
                    value: ''
                }, {
                    name: '1版',
                    value: '0'
                }, {
                    name: '2版',
                    value: '1'
                }, {
                    name: '3版',
                    value: '2'
                }];
            },
            searchKeyType: function() {
                return [{
                    name: '全部',
                    value: ''
                }, {
                    name: 'ID',
                    value: 'DocID'
                }, {
                    name: '共享人',
                    value: 'Cruser'
                }, {
                    name: '标题',
                    value: 'docTitle'
                }, {
                    name: '正文',
                    value: 'Content'
                }, {
                    name: '作者',
                    value: 'AuthorTruename'
                }];
            },
            addNewSearchType: function() {
                return [
                    {
                        name: '全部',
                        value: ''
                    },
                    {
                        name: '标题',
                        value: 'docTitle'
                    },
                    {
                        name: '正文',
                        value: 'Content'
                    }
                ];
            },
            searchBigdataType: function() {
                return [{
                    name: '全部',
                    value: '0'
                }, {
                    name: '标题',
                    value: '1'
                }, {
                    name: '作者',
                    value: '2'
                }];
            },
            // 邮件稿稿件类型
            emailNewsdocTypes: function() {
                return [{
                    name: '稿件类型',
                    value: '0'
                }, {
                    name: '新闻稿件',
                    value: '1'
                }, {
                    name: '图集稿件',
                    value: '2'
                }];
            },
            // 排序方式
            shareSort: function() {
                return [{
                    name: '排序方式',
                    value: ''
                }, {
                    name: '时间倒排',
                    value: 'time'
                }, {
                    name: '相关度',
                    value: ''
                }];
            },
            // 日志管理时间
            logMgrTime: function() {
                return [{
                    name: '全部时间',
                    value: 'all'
                }, {
                    name: '近一个月',
                    value: '1m'
                }];
            },
            // 日志管理类型
            logMgrType: function() {
                return [{
                    name: '全部渠道',
                    value: ''
                }, {
                    name: '我的',
                    value: '-1'
                }, {
                    name: 'APP',
                    value: '1'
                }, {
                    name: '网站',
                    value: '2'
                }, {
                    name: '报纸',
                    value: '3'
                }, {
                    name: '微信',
                    value: '4'
                }, {
                    name: '微博',
                    value: '5'
                }, {
                    name: '电视',
                    value: '15'
                }, {
                    name: '广播',
                    value: '16'
                }, {
                    name: '抖音',
                    value: '17'
                }, {
                    name: '百家号',
                    value: '18'
                }, {
                    name: '企鹅号',
                    value: '19'
                }, {
                    name: '头条号',
                    value: '20'
                }
                ];
            },
            // 原创稿类型
            originType: function() {
                return [{
                    name: '原创稿类型',
                    value: '0'
                }, {
                    name: '整合原创',
                    value: '1'
                }, {
                    name: '内部原创',
                    value: '2'
                }, {
                    name: '特约稿',
                    value: '3'
                }, {
                    name: '通讯员稿',
                    value: '4'
                }, {
                    name: '报道组稿',
                    value: '5'
                }, {
                    name: '其他',
                    value: '6'
                }];
            },
        };
    });
